import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Base URL for all backend calls, resolved from the active environment
 * (dev.iotzen.app locally, demo.iotzen.app for demo, api.iotzen.app for prod).
 *
 * Inject it in data services:
 *   private readonly baseUrl = inject(API_BASE_URL);
 *   this.http.get(`${this.baseUrl}/products`);
 */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  providedIn: 'root',
  factory: () => environment.apiBaseUrl,
});
